import { useContext } from 'react';
import { FinancialStatusContext } from '../context/financial-status-context';
import CaseInformation from './steps/case-information';
import ContactInformation from './steps/contact-information';
import Addressinformation from './steps/address-information';
import Determination from './steps/determination';
import EmploymentIncome from './steps/employment-income';
import Assets from './steps/assets';
import Debts from './steps/debts';
import Expenses from './steps/expenses';
import Signature from './steps/signature';
import FinalStep from './steps/final-step';

export default function FormController() {
	const financialContext = useContext(FinancialStatusContext);
	return (
		<div className="h-full">
			<div className={financialContext.currentStep === 0 ? 'block h-full' : 'hidden h-full'}>
				<CaseInformation />
			</div>
			<div className={financialContext.currentStep === 1 ? 'block h-full' : 'hidden h-full'}>
				<ContactInformation />
			</div>
			<div className={financialContext.currentStep === 2 ? 'block h-full' : 'hidden h-full'}>
				<Addressinformation />
			</div>
			<div className={financialContext.currentStep === 3 ? 'block h-full' : 'hidden h-full'}>
				<Determination />
			</div>
			<div className={financialContext.currentStep === 4 ? 'block h-full' : 'hidden h-full'}>
				<EmploymentIncome />
			</div>
			<div className={financialContext.currentStep === 5 ? 'block h-full' : 'hidden h-full'}>
				<Assets />
			</div>
			<div className={financialContext.currentStep === 6 ? 'block h-full' : 'hidden h-full'}>
				<Debts />
			</div>
			<div className={financialContext.currentStep === 7 ? 'block h-full' : 'hidden h-full'}>
				<Expenses />
			</div>
			<div className={financialContext.currentStep === 8 ? 'block h-full' : 'hidden h-full'}>
				<Signature />
			</div>
			<div className={financialContext.currentStep === 9 ? 'block h-full' : 'hidden h-full'}>
				<FinalStep />
			</div>
		</div>
	);
}
